import { User } from 'model';
import { ChangeEvent, useState } from 'react';
import { Input } from '../../components/Forms/Input.js';
import { UserItem } from '../../components/admin/UserItem.js';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../../styles/Shared.module.css';
import styles from './AddTokenModal.module.css';
export const AddTokenModal: React.FC<{
	user: User | undefined;
	setAddTokenAmountSubmit: (val: number) => void;
}> = ({ user, setAddTokenAmountSubmit }) => {
	const [addTokenAmount, setTokenAmount] = useState<number | ''>('');

	const createLedger = (e: ChangeEvent<HTMLInputElement>) => {
		const inputValue = e.target.value === '' ? '' : Number(e.target.value);
		setTokenAmount(inputValue);
		setAddTokenAmountSubmit(Number(inputValue));
	};

	return (
		<div>
			<div className={sharedStyles.userContainer}>{user && <UserItem user={user} modal={true} />}</div>
			<h4 style={{ marginBottom: '40px' }}>Add Token amount</h4>
			<div className={styles.dollarFormField}>
				<h3>$</h3>
				{user && (
					<Input
						type="number"
						placeholder="Token Amount"
						tabIndex={1}
						value={addTokenAmount}
						onChange={createLedger}
					/>
				)}
			</div>
			<div className="space20" />
		</div>
	);
};
